import { createSelector } from 'reselect';

import { selectEntitiesPlayersEntity } from '../../../../selectors/entities/players/entitiesPlayersPrimary.selector';
import { makeMatchBetsArraySelector } from '../../../../selectors/match.selector';
import { PlayerBasketStats } from '../../../../states/entities/players';
import { SelectorMaker, Selector } from '../../../../types/selectors';
import { makeMarketIdFromFilterIdSelector } from '../../selectors/lineUp.selector';

type LineUpPlayerStatsPropsType = {
  value?: number;
};

const makeLineUpPlayerStatsPropsSelector: SelectorMaker<LineUpPlayerStatsPropsType> = () => {
  const selectCurrentStatKeyFromFilter: Selector<keyof PlayerBasketStats | undefined> = createSelector(
    [makeMatchBetsArraySelector(), makeMarketIdFromFilterIdSelector()],
    (bets, marketId) => bets.find((bet) => marketId === bet.marketId)?.playerStats,
  );

  return createSelector([selectEntitiesPlayersEntity, selectCurrentStatKeyFromFilter], (player, key) => ({
    value: key && player ? player[key] : undefined,
  }));
};

export default makeLineUpPlayerStatsPropsSelector;
